import { jsxs, jsx } from 'react/jsx-runtime';
import { HeartShortlisted, NewCarsV2, Electric, CarLoanV2, EShopV2, MdV2, AccessoriesV2, InsuranceV2, ArticlesV2, ForumV2, ResourcesV2, Close } from '@sgcmpteltd/uikit-react';
import { M as MemberLink, b as MEMBER_LINK_VARIANT_MOBILE } from './component-DV6bFT4K.js';
import { S as SgcmLogo, b as SGCM_LOGO_VARIANT_MOBILE } from './component-D5qJ4zZ9.js';
import { Reward } from '@sgcmpteltd/uikit-icon';
import { Hybrid } from '@sgcmpteltd/uikit-react/components/icons';
import { b as HEADER_ITEM_TYPE_SINGLE, a as HEADER_ITEM_TYPE_CUSTOM, H as HEADER_ITEM_TYPE_BOTTOM, M as MenuItem } from './component-DS-1p45G.js';
import { M as MenuItem$2 } from './component-DizdA0Ns.js';
import { M as MenuItem$1 } from './component-DWXvkg0J.js';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const headerConfigList = () => [
    {
        key: 'rewards',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Reward,
                showShoppingCart: false,
                link: {
                    href: 'https://sgcarmart.com/account/rewards',
                    key: 'myRewards',
                    text: 'My Rewards',
                },
            },
        ],
    },
    {
        key: 'shortlist',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: HeartShortlisted,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/main/shortlist.php',
                    key: 'myShortlist',
                    text: 'My Shortlist',
                },
            },
        ],
    },
    {
        key: 'cart',
        group: [
            {
                type: HEADER_ITEM_TYPE_CUSTOM,
                icon: 'https://i.i-sgcm.com/mobile/sidebar/shopping-cart.svg',
                showShoppingCart: true,
                size: 24,
                link: {
                    href: 'https://m.sgcarmart.com/shop',
                    key: 'cart',
                    text: 'Shopping Cart',
                },
            },
        ],
    },
    {
        key: 'buyCars',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: NewCarsV2,
                showShoppingCart: false,
                link: {
                    href: 'https://sgcarmart.com/new-cars',
                    key: 'new',
                    text: 'New',
                },
            },
            {
                type: HEADER_ITEM_TYPE_CUSTOM,
                icon: 'https://i.i-sgcm.com/mobile/sidebar/used-car.svg',
                showShoppingCart: false,
                size: 20,
                link: {
                    href: 'https://sgcarmart.com/used-cars',
                    key: 'usedCars',
                    text: 'Used',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Electric,
                showShoppingCart: false,
                link: {
                    href: 'https://sgcarmart.com/electric-vehicle',
                    key: 'electricVehicle',
                    text: 'Electric',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Hybrid,
                showShoppingCart: false,
                link: {
                    href: 'https://sgcarmart.com/hybrid-vehicle',
                    key: 'hybridVehicle',
                    text: 'Hybrid',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: CarLoanV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/car_loan/index.php',
                    key: 'carLoan',
                    text: 'Loan',
                },
            },
            {
                type: HEADER_ITEM_TYPE_CUSTOM,
                icon: 'https://i.i-sgcm.com/mobile/sidebar/car-rental.svg',
                showShoppingCart: false,
                size: 20,
                link: {
                    href: 'https://m.sgcarmart.com/car_rental/index.php',
                    key: 'rentalCars',
                    text: 'Rent',
                },
            },
        ],
    },
    {
        key: 'sellCars',
        group: [
            {
                type: HEADER_ITEM_TYPE_CUSTOM,
                icon: 'https://i.i-sgcm.com/mobile/sidebar/sell-car.svg',
                showShoppingCart: false,
                size: 20,
                link: {
                    href: 'https://sgcarmart.com/sell-car/',
                    key: 'sell',
                    text: 'Sell',
                },
            },
        ],
    },
    {
        key: 'carsAssistance',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: EShopV2,
                showShoppingCart: false,
                link: {
                    href: 'https://www.sgcarmart.com/shop',
                    key: 'eShop',
                    text: 'e-Shop',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: MdV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/directory/index.php',
                    key: 'motorDirectory',
                    text: 'Motor Directory',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: AccessoriesV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/accessories/index.php',
                    key: 'accessories',
                    text: 'Accessories',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: InsuranceV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/directory/insurance.php',
                    key: 'insurance',
                    text: 'Insurance',
                },
            },
        ],
    },
    {
        key: 'articles',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: ArticlesV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/articles',
                    key: 'articles',
                    text: 'Articles',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: ForumV2,
                showShoppingCart: false,
                link: {
                    href: 'https://m.sgcarmart.com/forum/index.php',
                    key: 'forum',
                    text: 'Forum',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: ResourcesV2,
                showShoppingCart: false,
                link: {
                    href: 'https://www.sgcarmart.com/resources',
                    key: 'resources',
                    text: 'Resources',
                },
            },
        ],
    },
    {
        key: 'app',
        group: [
            {
                type: HEADER_ITEM_TYPE_BOTTOM,
                title: 'Download Mobile Apps',
                linkList: [
                    {
                        key: 'Apple app store icon',
                        text: 'https://i.i-sgcm.com/mobile/sidebar/download-via-applestore.svg',
                        href: 'https://itunes.apple.com/us/app/sgcarmart/id962261200?mt=8',
                    },
                    {
                        key: 'Google play store icon',
                        text: 'https://i.i-sgcm.com/all/icon_pl.png',
                        href: 'https://play.google.com/store/apps/details?id=com.sgcarmart.app',
                    },
                ],
            },
        ],
    },
];

var css_248z = "@font-face {\n  font-display: swap;\n  font-family: Graphik;\n  font-weight: 500;\n  src: url(\"src/fonts/graphik/woff/medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Graphik;\n  font-weight: 400;\n  src: url(\"src/fonts/graphik/woff/regular.woff\") format(\"woff\");\n}\n.SGCM_UIKIT_NEXT_Content_contentRoot_1bapx_13 {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  color: #333333;\n  font-size: 12px;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerSgcmLogo_1bapx_21 {\n  position: relative;\n  display: flex;\n  height: 54px;\n  flex: none;\n  padding: 0 30px;\n  background-color: white;\n  line-height: 0;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerSgcmLogo_1bapx_21 a {\n  margin: auto 0;\n}\n\n.SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_1bapx_35 {\n  overflow: auto;\n  flex: 1;\n}\n@supports (scrollbar-width: none) {\n  .SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_1bapx_35 {\n    scrollbar-width: none;\n  }\n}\n.SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_1bapx_35::-webkit-scrollbar {\n  display: none;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerUserLogin_1bapx_48 {\n  display: grid;\n  height: 40px;\n  padding: 0 27px;\n  background-color: white;\n  font-size: 12px;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerGuestLinks_1bapx_56 {\n  display: flex;\n  align-items: center;\n  margin: auto 0;\n  column-gap: 12px;\n}\n\n.SGCM_UIKIT_NEXT_Content_dividerLinkMember_1bapx_63 {\n  width: 1px;\n  height: 12px;\n  background-color: #dfdfdf;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(4) > a, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(3) > a, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(2) > a, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(1) > a {\n  height: 40px;\n  margin-bottom: 0;\n}\n.SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(4) svg, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(3) svg, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(2) svg, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(1) svg, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(4) img, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(3) img, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(2) img, .SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(1) img {\n  width: 24px;\n  height: 24px;\n}\n.SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69:nth-child(4) {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dfdfdf;\n  margin-bottom: 10px;\n}\n\n.SGCM_UIKIT_NEXT_Content_closeBtn_1bapx_83 {\n  position: absolute;\n  top: 18px;\n  right: 30px;\n  color: #999;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles = {"contentRoot":"SGCM_UIKIT_NEXT_Content_contentRoot_1bapx_13","containerSgcmLogo":"SGCM_UIKIT_NEXT_Content_containerSgcmLogo_1bapx_21","conatinerMenuItemList":"SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_1bapx_35","containerUserLogin":"SGCM_UIKIT_NEXT_Content_containerUserLogin_1bapx_48","containerGuestLinks":"SGCM_UIKIT_NEXT_Content_containerGuestLinks_1bapx_56","dividerLinkMember":"SGCM_UIKIT_NEXT_Content_dividerLinkMember_1bapx_63","containerHeaderItemGroup":"SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_1bapx_69","closeBtn":"SGCM_UIKIT_NEXT_Content_closeBtn_1bapx_83"};
styleInject(css_248z);

const Content = ({ baseUrlMap, user, os, onClose, shoppingCartCounterValue = 0, }) => (jsxs("div", { className: styles.contentRoot, children: [jsx("div", { className: styles.containerSgcmLogo, children: jsx(SgcmLogo, { baseUrlMap: baseUrlMap, variant: SGCM_LOGO_VARIANT_MOBILE }) }), jsx("div", { className: styles.closeBtn, onClick: onClose, children: jsx(Close, { size: 18 }) }), jsxs("div", { className: styles.conatinerMenuItemList, children: [jsx("div", { className: styles.containerUserLogin, children: jsx(MemberLink, { user: user, variant: MEMBER_LINK_VARIANT_MOBILE }) }), headerConfigList().map(({ key, group }) => (jsx("div", { className: styles.containerHeaderItemGroup, children: group.map((groupData) => {
                        const { type } = groupData;
                        if (type === HEADER_ITEM_TYPE_SINGLE) {
                            const { link, icon, showShoppingCart } = groupData;
                            return (jsx(MenuItem, { icon: icon, link: link, 
                                // eslint-disable-next-line @stylistic/max-len
                                shoppingCartCounterValue: showShoppingCart ? shoppingCartCounterValue : 0 }, `${key}-${link.href}`));
                        }
                        if (type === HEADER_ITEM_TYPE_CUSTOM) {
                            const { link, icon, showShoppingCart } = groupData;
                            return (jsx(MenuItem$1, { icon: icon, link: link, 
                                // eslint-disable-next-line @stylistic/max-len
                                shoppingCartCounterValue: showShoppingCart ? shoppingCartCounterValue : 0 }, `${key}-${link.href}`));
                        }
                        if (type === HEADER_ITEM_TYPE_BOTTOM) {
                            const { title, linkList } = groupData;
                            return (
                            // eslint-disable-next-line react/jsx-key
                            jsx(MenuItem$2, { linkList: linkList, title: title }));
                        }
                        return null;
                    }) }, key)))] })] }));

export { Content as C };
//# sourceMappingURL=component-BvjbUsm_.js.map
